<div fxLayout="column" class="navigation-container" [style.width.px]="width">
  @for (navigationEntry of navigationEntries; track navigationEntry) {
    <abc-button
      [ngClass]="{ active: navigationEntry.isSelected }"
      class="control-button"
      (click)="loadComponent(navigationEntry)"
      [id]="navigationEntry.componentName"
      [stylingMode]="'text'"
      type="normal"
      [toolTipContent]="navigationEntry.toolTip"
      [icon]="navigationEntry.icon"
      >
    </abc-button>
  }
</div>
